(() => {
  if (window.rmProductReviewsInitialized) return;
  window.rmProductReviewsInitialized = true;

  const targetSelector = '[id="judgeme_product_reviews"], .jdgm-review-widget';

  function enhanceWidgets() {
    document.querySelectorAll('.jdgm-review-widget').forEach(widget => {
      if (widget.querySelector('.jdgm-carousel-review-list')) {
        widget.classList.add('rm-product-review-widget');
        const section = widget.closest('.jdgm-review-section-wrapper');
        const sectionTitle = section?.querySelector('h4');
        if (sectionTitle?.textContent.trim()) {
          widget.classList.add('rm-product-review-widget--has-section-title');
        }
      }
    });
  }

  function reviewTarget(link) {
    const productId = link.dataset.rmProductId;
    const targets = [...new Set(document.querySelectorAll(targetSelector))]
      .filter(element => !element.closest('.jdgm-legacy-widget-content'))
      .filter(element => !productId || (element.dataset.productId || element.dataset.id) === productId);
    return targets.find(element => element.getClientRects().length)
      || targets.find(element => element.closest('.jdgm-review-section-wrapper'));
  }

  document.addEventListener('click', event => {
    const link = event.target.closest('[data-rm-reviews]');
    if (!link || event.defaultPrevented || event.button !== 0
      || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = reviewTarget(link);
    if (!target) return;

    event.preventDefault();
    const section = target.closest('.jdgm-review-section-wrapper');
    section?.classList.add('has-reviews');
    for (let details = target.closest('details'); details; details = details.parentElement?.closest('details')) {
      details.open = true;
    }
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    (section || target).scrollIntoView({
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      block: 'start'
    });
  });

  // Judge.me mounts asynchronously and can remount in the theme editor.
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      enhanceWidgets();
    });
  });
  enhanceWidgets();
  observer.observe(document.body, { childList: true, subtree: true });
})();
